import React from "react";
import PortsIcon from "assets/img/svg/ports.svg?react";

interface ExposedPortsPieceProps {
  ports: Record<string, string> | null;
  firewallRules: string[] | null;
}

export const ExposedPortsPiece: React.FC<ExposedPortsPieceProps> = ({
  ports,
  firewallRules,
}) => {
  return (
    <div className="flex flex-col text-sm h-full items-start">
      <div className="flex flex-col  items-center text-gray-500 dark:text-white">
        <div className="flex flex-row mt-[2px] items-center">
          <PortsIcon height={"14px"} width={"32px"} />
          <div className="flex flex-row">
            <span className="text-sm ml-1">Exposed Ports</span>
          </div>
        </div>
        <div className="flex flex-col">
          {ports && Object.keys(ports).length > 0 && (
            <div className="flex flex-row w-full mt-1">
              <span className="text-xs font-bold mr-1">Tunnels:</span>
              <span className="text-xs max-w-[250px]">
                {Object.keys(ports)
                  .map((port) => `${port}:${ports[port]}`)
                  .join(" | ")}
              </span>
            </div>
          )}
          {firewallRules && firewallRules.length > 0 && (
            <div className="flex flex-row w-full mt-1">
              <span className="text-xs font-bold mr-1">Firewall Rules:</span>
              <span className="text-xs max-w-[250px]">
                {firewallRules.map((port) => `${port}`).join(" | ")}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
